import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from 'vue-router';
import BottomTouchBar from '@/components/BottomTouchBar.vue';
import TopNavMenu from './components/TopNavMenu.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(route).name !== 'Home')
      ? (_openBlock(), _createBlock(TopNavMenu, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_unref(route).name !== 'Home')
      ? (_openBlock(), _createBlock(BottomTouchBar, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})